module.exports = __webpack_public_path__ + "media/images/access-and-innovation-3cc762a57b32f5430a08b5a3dffbbc4d.jpg";